import React, { useState } from "react";
import ClosedBusinessReceivedTab from "./ClosedBusinessReceivedTab";
import ClosedBusinessReferredTab from "./ClosedBusinessReferredTab";
import ClosedBusinessBothTab from "./ClosedBusinessBothTab";
import { Button, Tooltip, MenuItem, TextField } from "@mui/material";
import ReportModal from "../../Modal/ReportModal";
import { defaultEditFormState } from "../../constant";
import TextSlider from "../../TextSlider/textSliderForClosedBusiness";
import dayjs from "dayjs";

const ClosedBusinessTab = ({ id, data }) => {
  const [activeTabs, setActiveTabs] = useState([0]);
  const [openModal, setOpenModal] = useState(false);
  const [timeframe, setTimeframe] = useState(
    dayjs().subtract(1, "year").format("YYYY-MM-DD"),
  );

  const handleTabToggle = (tabIndex) => {
    setActiveTabs((prevTabs) =>
      prevTabs.includes(tabIndex)
        ? prevTabs.length > 1
          ? prevTabs.filter((tab) => tab !== tabIndex)
          : prevTabs
        : [...prevTabs, tabIndex],
    );
  };

  const handleClick = () => {
    const reportType =
      activeTabs.includes(0) && activeTabs.includes(1)
        ? "both"
        : activeTabs.includes(0)
          ? "sent"
          : "received";

    setOpenModal({
      open: true,
      data: data,
      type: reportType,
    });
  };

  const getTooltipText = () => {
    if (activeTabs.includes(0) && activeTabs.includes(1)) {
      return "Printing Closed Business Referred and Received";
    } else if (activeTabs.includes(0)) {
      return "Printing Closed Business Referred";
    } else if (activeTabs.includes(1)) {
      return "Printing Closed Business Received";
    }
  };

  return (
    <>
      <div className="flex flex-col gap-4">
        <TextField
          margin="normal"
          id="timeframe"
          label="Timeframe"
          name="timeframe"
          value={timeframe}
          onChange={(e) => {
            setTimeframe(e.target.value);
          }}
          className="timeframe-select"
          size="small"
          select
          sx={{
            width: "178px",
          }}
        >
          <MenuItem value={dayjs().subtract(1, "year").format("YYYY-MM-DD")}>
            1 year
          </MenuItem>
          <MenuItem value={dayjs().subtract(6, "month").format("YYYY-MM-DD")}>
            6 months
          </MenuItem>
          <MenuItem value={dayjs().subtract(3, "month").format("YYYY-MM-DD")}>
            3 months
          </MenuItem>
          <MenuItem value={dayjs().subtract(1, "month").format("YYYY-MM-DD")}>
            1 month
          </MenuItem>
          <MenuItem value="all">All Time</MenuItem>
        </TextField>

        <div className="flex justify-between items-center flex-wrap gap-8">
          <TextSlider
            activeTabs={activeTabs}
            handleTabToggle={handleTabToggle}
            tab1="Closed Business Referred"
            tab2="Closed Business Received"
          />
          <Tooltip title={getTooltipText()} arrow>
            <Button
              onClick={handleClick}
              className="add-new-button button-common"
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
            >
              Closed Business Report
            </Button>
          </Tooltip>
        </div>
      </div>

      <div className="mt-4">
        {activeTabs.includes(0) && activeTabs.includes(1) ? (
          <ClosedBusinessBothTab id={id} timeframe={timeframe} />
        ) : activeTabs.includes(0) ? (
          <ClosedBusinessReferredTab id={id} timeframe={timeframe} />
        ) : (
          <ClosedBusinessReceivedTab id={id} timeframe={timeframe} />
        )}
      </div>

      {openModal?.open && (
        <ReportModal
          open={openModal?.open}
          handleClose={() => setOpenModal(defaultEditFormState)}
          closedBusiness
          title="Closed Business Report"
          type={openModal?.type}
          data={openModal?.data}
        />
      )}
    </>
  );
};

export default ClosedBusinessTab;
